import { Alert, Button, Container, Group, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { HOME_PATH } from "../auth/redirectTarget";
import { useAuthStore } from "../auth/store";
import { useHealthz } from "../features/health/useHealthz";

// Стартовая страница / лендинг.
//
// Заголовок «Baton» + диагностическая кнопка healthz.
// Точка входа в приложение: если JWT ещё нет — кнопки «Войти»
// и «Регистрация» (формы на `/login` и `/register`). Если токен уже
// есть (вернулись на `/` залогиненными) — «Открыть приложение»
// (→ `/home`), чтобы не застрять на голом лендинге. Кнопка проверки
// backend остаётся, но уже не единственный элемент.
export function HelloPage(): ReactElement {
  const { t } = useTranslation();
  const health = useHealthz();
  const authUserId = useAuthStore((state) => state.identity?.userId ?? null);

  const onCheck = (): void => {
    // `void` — обещание от refetch выбрасываем намеренно: TanStack
    // Query сам сохраняет статус в стор, в JSX мы читаем `health.*`.
    void health.refetch();
  };

  return (
    <Container py="xl">
      <Stack gap="md">
        <Title order={1}>{t("app.title")}</Title>

        <Group>
          {authUserId === null ? (
            <>
              <Button component={Link} to="/login">
                {t("landing.login")}
              </Button>
              <Button component={Link} to="/register" variant="default">
                {t("landing.register")}
              </Button>
            </>
          ) : (
            <Button component={Link} to={HOME_PATH}>
              {t("landing.openApp")}
            </Button>
          )}
        </Group>

        <Button onClick={onCheck} loading={health.isFetching} variant="subtle">
          {t("health.checkButton")}
        </Button>

        {health.isSuccess ? (
          <Alert color="green" title={t("health.okHeading")}>
            {t("health.okBody")}
          </Alert>
        ) : null}

        {health.isError ? (
          <Alert color="red" title={t("health.errorHeading")}>
            {t("health.error", { message: health.error.message })}
          </Alert>
        ) : null}
      </Stack>
    </Container>
  );
}
